import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import Pillars from './components/Pillars';
import Differentiators from './components/Differentiators';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Services from './pages/Services';
import Capabilities from './pages/Capabilities';
import About from './pages/About';
import Contact from './pages/Contact';
import Engagement from './pages/Engagement';
import Insights from './pages/Insights';
import BookCall from './pages/BookCall';
import AIIntegration from './pages/AIIntegration';
import Careers from './pages/Careers';
import PrivacyPolicy from './pages/Legal';
import TermsOfService from './pages/TermsOfService';
import FloatingCTA from './components/FloatingCTA';
import WhoWeServe from './components/WhoWeServe';
import CaseStudies from './components/CaseStudies';

// New components
import FAQ from './components/FAQ';
import Newsletter from './components/Newsletter';
import NotFound from './pages/NotFound';
import CookieConsent from './components/CookieConsent';
import ScrollToTopButton from './components/ScrollToTopButton';
import CustomCursor from './components/ux/CustomCursor';

import InsightDetail from './pages/InsightDetail';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => (
  <>
    <Hero />
    <TrustStrip />
    <WhoWeServe />
    <Pillars />
    <CaseStudies />
    <Differentiators />
    <Process />
    <FAQ />
    <Testimonials />
    <Newsletter />
  </>
);

import { ThemeProvider } from './context/ThemeContext';

function App() {
  useEffect(() => {
    // Initialize Lenis for smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <CustomCursor />
        <div className="min-h-screen bg-white dark:bg-slate-950 font-sans selection:bg-cyan-500/10 transition-colors duration-300">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/engagement" element={<Engagement />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/book-call" element={<BookCall />} />
              <Route path="/ai-integration" element={<AIIntegration />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              
              {/* Catch-all 404 Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <FloatingCTA />
          <ScrollToTopButton />
          <CookieConsent />
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;